var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTronLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57713 2.20599C3.65331 2.12231 3.75062 2.06069 3.85883 2.02761C3.96705 1.99453 4.08218 1.99121 4.19213 2.01799L17.4181 5.25599C17.4981 5.27466 17.5711 5.30866 17.6371 5.35799L20.3281 7.32099C20.4591 7.4172 20.5478 7.56028 20.5758 7.72035C20.6037 7.88042 20.5687 8.0451 20.4781 8.18L11.2191 21.726C11.1541 21.822 11.0637 21.8981 10.958 21.9457C10.8522 21.9933 10.7354 22.0105 10.6204 21.9955C10.5054 21.9804 10.3969 21.9337 10.3069 21.8605C10.217 21.7873 10.1492 21.6905 10.1111 21.581L3.45013 2.83699C3.41268 2.73034 3.40462 2.61557 3.42679 2.50473C3.44895 2.39388 3.50054 2.29104 3.57613 2.20699M5.76013 5.58999L10.3821 18.603L11.1421 11.86L5.76013 5.58999ZM12.3801 12.077L11.6081 18.937L18.1451 9.371L12.3801 12.077ZM18.7351 7.70999L14.5231 9.687L17.3451 6.69699L18.7351 7.70999ZM16.0731 6.21799L5.79013 3.69999L11.8191 10.72L16.0731 6.21799Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronLogo);
export default __webpack_public_path__ + "static/media/tron_logo.69ab3251b2217e0c139e5eb71fe9db49.svg";
export { ForwardRef as ReactComponent };